// Anciens noms de couleurs du prototype XDIAL, gardés pour le kit
// components/xdial. Ils ne portent plus de valeur : tailwind.config.js les
// fait pointer sur les jetons --vf-* de DESIGN.md (source unique, W1).

// Clés de couleur reconnues par le kit (classes Tailwind bg-<clé>, text-<clé>).
export const TOKEN_KEYS = [
  'bg', 's', 's2', 's3', 'bd', 'tx', 't2', 'tm',
  'ac', 'ab', 'ax',
  'gn', 'gb', 'rd', 'rb', 'or', 'ob', 'bl', 'bb',
  'pr', 'pb', 'pk', 'pkb', 'cy', 'cyb', 'yl', 'ylb',
] as const;
export type TokenKey = (typeof TOKEN_KEYS)[number];

export type ProspectStatusKey =
  | 'new'
  | 'contacted'
  | 'qualified'
  | 'callback'
  | 'not_interested'
  | 'booked';

// Score → couleur (scCol() du proto) : >=80 gn, >=60 or, >=40 bl, sinon rd.
export function scoreColorToken(v: number): TokenKey {
  if (v >= 80) return 'gn';
  if (v >= 60) return 'or';
  if (v >= 40) return 'bl';
  return 'rd';
}
